import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App404 from "./app/main/App404.js";
import AppMainContainers from "./redux/containers/AppMainContainers.js";
import AppMyQrcode from './app/qrcode/AppMyQrcode.js';
function AppRoutes() {
  return (
    <Router basename="/">
      <div>
        <Routes>
          <Route path="/" element={
            <Suspense fallback={<div>Loading...</div>}>
              <AppMainContainers />
            </Suspense>
          } />
          <Route path="/qrcode" element={
            <Suspense fallback={<div>Loading...</div>}>
              <AppMyQrcode />
            </Suspense>
          } />
          <Route element={
            <Suspense fallback={<div>Loading...</div>}>
              <App404 />
            </Suspense>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default AppRoutes;
